export enum ResearchIndexes {
    Research = 'research',
    Assets = 'assets',
    Proposal = 'proposal',
    BWRSearch = 'bwr-search',
}
